const delimiter = '; '

export function setCookie(
  name: string,
  value: string,
  { maxAge = 60 * 60 * 24 * 30 /* 30日間 */, domain }: { maxAge?: number; domain?: string } = {},
) {
  const parts = [`${name}=${value}`, `path=/`, `max-age=${maxAge}`, 'samesite=lax', 'secure']
  if (domain) parts.push(`domain=${domain}`)
  document.cookie = parts.join(delimiter)
}

export function getCookie(name: string): string | null {
  return (
    document.cookie
      .split(delimiter)
      .find((part) => part.startsWith(`${name}=`))
      ?.split('=')
      .at(1) || null
  )
}

export function deleteCookie(name: string, { domain }: { domain?: string } = {}) {
  const parts = [`${name}=`, `path=/`, 'max-age=0', 'samesite=lax', 'secure']
  if (domain) parts.push(`domain=${domain}`)
  document.cookie = parts.join(delimiter)
}
